<!-- Sidebar Template - Feature: 012-desktop-mobile-shells -->
<!-- patientCount$ subscription triggers re-render when patients load -->
@if (patientCount$ | async; as _patientCount) {}
<nav class="sidebar" role="navigation" [attr.aria-label]="'SHELL.SIDEBAR_NAVIGATION' | translate">
  <mat-nav-list>
    @for (item of navItems; track item.route) {
      <a mat-list-item
         [routerLink]="item.route"
         routerLinkActive="active"
         class="sidebar__nav-item"
         [attr.aria-label]="getLabelKey(item) | translate">
        <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
        <span matListItemTitle>{{ getLabelKey(item) | translate }}</span>
        @if (showsUnreadBadge(item) && (unreadCount$ | async); as unreadCount) {
          <span
            class="sidebar__badge"
            matListItemMeta
            [attr.aria-label]="'NAV.MESSAGES_UNREAD_BADGE' | translate:{ count: unreadCount }">
            {{ badgeLabel(unreadCount) }}
          </span>
        }
      </a>
    }
  </mat-nav-list>
</nav>
